/** "Asha Rao" -> "AR"; no name -> the last two digits of the phone. */
export const initialsFor = (name, phone) => {
  const source = String(name || '').trim();
  if (source) {
    const parts = source.split(/\s+/).filter(Boolean);
    return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
  }
  const digits = String(phone || '').replace(/\D/g, '');
  return digits.slice(-2) || '?';
};
